export const headerTextStyles = {
  fontWeight: "bold",
};
export const centerTextStyles = {
  textAlign: "center",
};
export const bodyTextStyles = {};
